import { videoRenderer } from "@grindex-common/helpers/videoRenderer";

const VIDEO_CONTAINER = "div.video";
const SELECTOR_SLIDER = "ul.bxslider";

function initializeVideo(embedIdentifier, videoPlayerId) {
	var jwConfig = {
		autostart: false,
		controls: true,
		displaydescription: true,
		displaytitle: false,
		ga: {
			idstring: "title",
		},
		height: 360,
		mute: false,
		playbackRateControls: false,
		playlist: `//content.jwplatform.com/v2/media/${embedIdentifier}?recommendations_playlist_id=jKZAX3QF`,
		preload: "metadata",
		repeat: false,
		sharing: {
			code:
				"%3Ciframe%20src%3D%22//cdn.jwplayer.com/players/MEDIAID-zZ6zbae7.html%22%20width%3D%22480%22%20" +
				"height%3D%22360%22%20frameborder%3D%220%22%20scrolling%3D%22auto%22%3E%3C/iframe%3E",
			sites: ["facebook", "twitter", "email", "googleplus", "linkedin"],
		},
		stretching: "uniform",
		width: 480,
	};

	const $containerDiv = document.createElement("div");
	$containerDiv.id = "botr_" + embedIdentifier + "_" + videoPlayerId + "_div";

	jwplayer($containerDiv).setup(jwConfig);

	return $containerDiv;
}

function scriptRender(url, renderJwplayerVideo) {
	var jwplayerScript = document.createElement("script");
	var jwplayerKey = document.createElement("script");

	const apiUrl = `/api/integrity/calculatehash?filePath=${url}`;

	fetch(apiUrl)
		.then((response) => response.json())
		.then((res) => {
			jwplayerScript.addEventListener("load", function () {
				jwplayerKey.textContent = 'jwplayer.key = "+ChdgpMdS/dGcsn3rMYpA6Q0C5r9YKEYHWsp10Epr7m8WpvL"';
				document.getElementsByTagName("head")[0].appendChild(jwplayerKey);
				renderJwplayerVideo();
				resizeVideo();
				playCarouselVideos();
			});
			jwplayerScript.src = `/${url}`;
			jwplayerScript.id = "jwplayerScript";
			jwplayerScript.integrity = res.integrityHashCode;
			document.getElementsByTagName("head")[0].appendChild(jwplayerScript);
		});
}

function isScriptRendered() {
	return document.getElementById("jwplayerScript") ? true : false;
}

function resizeVideo() {
	$(".js-video-resize").each(function (e) {
		if (typeof jwplayer !== "undefined") {
			videoRenderer.renderDefaultVideo(e);
		} else {
			return;
		}
	});
}

function configJwplayer($player) {
	$player.setConfig({
		autostart: "true",
		mute: true,
		width: "100%",
	});

	$player.setControls(false);
}

function playJwplayer(id) {
	const $player = window.jwplayer(id);

	$player.on("ready", () => {
		configJwplayer($player);
		$player.play(true);
	});

	$player.on("beforeComplete", () => {
		$player.seek(0);
		$player.play(true);
	});

	configJwplayer($player);
	$player.play(true);
}

function playVideos(parent) {
	parent.querySelectorAll(VIDEO_CONTAINER).forEach((element) => {
		// Handle jwplayer container
		if (element.classList.contains("jw-container")) {
			// children[0].children[0] have div element which have jwplayer
			const $jwplayer = element.children[0].children[0];

			if ($jwplayer) {
				playJwplayer($jwplayer.id);
			}
		} else {
			const $video = element.querySelector("video");

			if ($video && $video.offsetWidth) {
				$video.play();
			}
		}
	});
}

function playCarouselVideos() {
	const $sliders = $(SELECTOR_SLIDER);
	if ($sliders.length === 0) {
		return;
	}

	for (let i = 0; i < $sliders.length; i = i + 1) {
		let $slider = $sliders[i];

		playVideos($slider.parentElement);
	}
}

export { initializeVideo, scriptRender, isScriptRendered };
